<header class="content-header">
  <h4 class="vision-h4">{{ (data.protocol ? 'viewerProtocols.editor.editHeader' : 'viewerProtocols.editor.createHeader') | translate }}</h4>
</header>

<div mat-dialog-content>
  <p class="subheader">
    {{ 'viewerProtocols.editor.subheader' | translate }}
    <a href="https://docs.flywheel.io/?q=creating+viewer+protocol" target="_blank">{{
      'viewerProtocols.editor.viewDocs' | translate }}</a>
  </p>
  <form [formGroup]="formGroup">
    <label [attr.aria-label]="'viewerProtocols.editor.protocolName' | translate">
      {{ 'viewerProtocols.editor.protocolName' | translate }}
    </label>
    <mat-form-field appearance="outline" class="full-width">
      <input test-id="protocol-label-input" formControlName="label" matInput [placeholder]="'viewerProtocols.editor.protocolNamePlaceholder' | translate">
      <mat-error *ngIf="formGroup.controls.label.hasError('required')">{{ 'viewerProtocols.editor.protocolNameRequired' | translate }}</mat-error>
      <mat-error *ngIf="formGroup.controls.label.hasError('duplicateLabel')">{{ 'viewerProtocols.editor.protocolNameExists' | translate }}</mat-error>
    </mat-form-field>

    <label [attr.aria-label]="'viewerProtocols.editor.protocolDesc' | translate">
      {{ 'viewerProtocols.editor.protocolDesc' | translate }}
    </label>
    <mat-form-field appearance="outline" class="full-width">
      <textarea test-id="protocol-desc-input" formControlName="description" matInput rows="4"
        [placeholder]="'viewerProtocols.editor.protocolDescPlaceholder' | translate"></textarea>
      <mat-error *ngIf="formGroup.controls.description.hasError('required')">{{ 'viewerProtocols.editor.protocolDescRequired' | translate }}</mat-error>
    </mat-form-field>

    <label [attr.aria-label]="'viewerProtocols.editor.viewerForm' | translate">
      {{ 'viewerProtocols.editor.viewerForm' | translate }}
      <fw-icon class="xs" [matTooltip]="'viewerProtocols.editor.viewerFormTooltip' | translate">information-circle</fw-icon>
    </label>
    <ng-container *ngIf="formGroup.controls.form_id.value">
      <div class="edit-resource">
        <span>ViewerForm.json</span>
        <button test-id="edit-viewer-form-button" mat-icon-button (click)="editResource('form')">
          <fw-icon>edit</fw-icon>
        </button>
      </div>
    </ng-container>
    <ng-container *ngIf="!formGroup.controls.form_id.value">
      <div class="upload-buttons">
        <button test-id="open-editor-form-button" mat-stroked-button color="primary" (click)="editResource('form')">
          {{ 'viewerProtocols.editor.openEmptyEditor' | translate }}
        </button>
        <button test-id="upload-form-button" mat-stroked-button color="primary" (click)="formFileInput.click()">
          {{ 'viewerProtocols.editor.uploadFile' | translate }}
        </button>
        <input class="hidden" type="file" accept=".json" #formFileInput (change)="selectFile('form', $event)">
      </div>
    </ng-container>

    <label [attr.aria-label]="'viewerProtocols.editor.viewerConfig' | translate">
      {{ 'viewerProtocols.editor.viewerConfig' | translate }}
      <fw-icon class="xs" [matTooltip]="'viewerProtocols.editor.viewerConfigTooltip' | translate">information-circle  </fw-icon>
    </label>
    <ng-container *ngIf="formGroup.controls.viewer_config_id.value">
      <div class="edit-resource">
        <span>ViewerConfig.json</span>
        <button test-id="edit-viewer-form-button" mat-icon-button (click)="editResource('viewerConfig')">
          <fw-icon>edit</fw-icon>
        </button>
      </div>
    </ng-container>
    <ng-container *ngIf="!formGroup.controls.viewer_config_id.value">
      <div class="upload-buttons">
        <button test-id="open-editor-config-button" mat-stroked-button color="primary" (click)="editResource('viewerConfig')">
          {{ 'viewerProtocols.editor.openEmptyEditor' | translate }}
        </button>
        <button test-id="upload-config-button" mat-stroked-button color="primary" (click)="configFileInput.click()">
          {{ 'viewerProtocols.editor.uploadFile' | translate }}
        </button>
        <input class="hidden" type="file" accept=".json" #configFileInput (change)="selectFile('viewerConfig', $event)">
      </div>
    </ng-container>
  </form>
</div>

<div class="action-buttons" mat-dialog-actions align="end">
  <button test-id="close-button" mat-stroked-button (click)="cancel()">{{ 'common.actions.cancel' | translate }}</button>
  <button test-id="save-button" mat-flat-button color="primary" (click)="submit()" [disabled]="formGroup.invalid">
    {{ 'common.actions.save' | translate }}
  </button>
</div>
